import React, { useEffect, useContext, useRef, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import * as yup from 'yup';
import getLocationValidationSchema from 'components/forms/my-location/getValidationSchema';
import { I18NContext, GlobalContext, I18N } from 'commons';
import AddLocationInformationForm from './Fields';
import Header from './Header';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const AddLocationForm = ({
  addresses,
  isOpenAddLocation,
  isOpenEditLocation,
  openAddLocation,
  closeLocation,
  address,
  isEmptyLocation,
  userAddressList,
  isEditMode,
  setSavedSucceed,
  isExpectedLocation,
  expLocEditable,
  isModalOpen,
}) => {
  const i18n = useContext(I18NContext);
  const {
    organization: {
      defaultCountry: defaultCountryCode = 'US',
      userStatus,
      addressSetting: { defaultAddressGeoCodingSource = '', editable: addresseEditable = false },
    },
    account: { id: contactId },
  } = useContext(GlobalContext);
  const [addressVerifyPass, setAddressVerifyPass] = useState(false);
  const [showAddressVerifyTip, setShowAddressVerifyTip] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const defaultLocationName = useMemo(() => {
    const nameList = Array.from(userAddressList, (addressItem) => addressItem.locationName);
    const defaultName = '';
    return (nameList.indexOf(defaultName) === -1) ? defaultName : '';
  }, [userAddressList, userStatus]);
  let locationValidationSchema = getLocationValidationSchema({
    addressValue: address.locationName || '',
    contactId,
    isExpectedLocation
  });
  if (!addresseEditable) {
    locationValidationSchema = {};
  }

  const defaultLocationValues = {
    locationName: address.locationName || defaultLocationName,
    street: address.streetAddress || '',
    suite: address.suite || '',
    city: address.city || '',
    postalCode: address.postalCode || '',
    state: address.state || '',
    country: address.country || defaultCountryCode,
    id: address.id || '',
    lat: isExpectedLocation ? (address?.gisLocation?.lat || '') : (address.lat || ''),
    lon: isExpectedLocation ? (address?.gisLocation?.lon || '') : (address.lon || ''),
    addressGeoCodingSource: address.addressGeoCodingSource
      || defaultAddressGeoCodingSource
      || 'Bing',
    pristineLocationName: address.locationName || '',
    locationId: address.locationId || '',
    arriveDate: address.arriveDate || '',
    expireDate: address.expireDate || '',
    locationSource: address.locationSource || '',
    travelSegment: address.travelSegment,
  };
  const nullLocationValues = {
    address: {},
  };

  return (
    <>
      <Modal isOpen={isModalOpen}>
        <ModalHeader title="test">{isExpectedLocation ? <I18N>ssp.title.locations.expected</I18N> : <I18N>ssp.title.locations.static</I18N>}
        </ModalHeader>
        <ModalBody>
          <div role="form" aria-labelledby="formTitle">
            <div id="formTitle">
              <Header isOpenAddLocation={isOpenAddLocation} />
            </div>
            <Formik
              initialValues={{
                ...defaultLocationValues,
              }}
              enableReinitialize
              validationSchema={() =>
                yup.object().shape({
                  ...locationValidationSchema,
                })
              }
              validateOnChange={false}
              onSubmit={() => { setIsSubmit(true); }}
            >
              {({
                values,
                touched,
                errors,
                setFieldError,
                setValues,
                setFieldValue,
                setFieldTouched,
                handleBlur,
                handleSubmit,
                isSubmitting
              }) => (
                <AddLocationInformationForm
                  isSubmitting={isSubmitting}
                  isSubmit={isSubmit}
                  setIsSubmit={setIsSubmit}
                  handleSubmit={handleSubmit}
                  currentAddress={address}
                  isEditMode={isEditMode}
                  isExpectedLocation={isExpectedLocation}
                  expLocEditable={expLocEditable}
                  isFullLocationPage
                  isOpenEditLocation={isOpenEditLocation}
                  openAddLocation={openAddLocation}
                  closeLocation={closeLocation}
                  setFieldError={setFieldError}
                  isAddressVerifyPass={addressVerifyPass}
                  setIsAddressVerifyPass={setAddressVerifyPass}
                  isShowAddressVerifyTip={showAddressVerifyTip}
                  setShowAddressVerifyTip={setShowAddressVerifyTip}
                  defaultLocationValues={defaultLocationValues}
                  isEmptyLocation={isEmptyLocation}
                  isOpenAddLocation={isOpenAddLocation}
                  setSavedSucceed={setSavedSucceed}
                  resetLocationValues={whichCall => {
                    if (whichCall === 'delete') {
                      setValues({ ...values, ...nullLocationValues });
                    } else {
                      setValues({ ...values });
                    }
                  }}
                  {...{
                    values,
                    touched,
                    errors,
                    setValues,
                    setFieldValue,
                    setFieldError,
                    setFieldTouched,
                    handleBlur,
                    userAddressList
                  }}
                />
              )}
            </Formik>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

AddLocationForm.propTypes = {
  isOpenAddLocation: PropTypes.bool.isRequired,
  isOpenEditLocation: PropTypes.bool.isRequired,
  openAddLocation: PropTypes.func.isRequired,
  closeLocation: PropTypes.func.isRequired,
  address: PropTypes.shape(),
  isEmptyLocation: PropTypes.bool.isRequired,
  userAddressList: PropTypes.array,
  isEditMode: PropTypes.bool,
};

AddLocationForm.defaultProps = {
  address: {},
  userAddressList: [],
  isEditMode: false
};

export default AddLocationForm;
